import { useTranslation } from 'react-i18next';
import { Controller, useWatch } from 'react-hook-form';

import { useAdvancedSearchFormContext } from '../../types';

import { NumberFieldWrapper } from './numberFieldWrapper';

export const GardsnummerField = () => {
  const { t } = useTranslation();
  const label = t('search.advanced.field_gardsnummer');
  const { control, trigger } = useAdvancedSearchFormContext();

  const bygningsnummer = useWatch({ control, name: 'bygningsnummer' });

  return (
    <Controller
      rules={{
        validate: {
          required: (value) => {
            //Message vil be filtered out and replaced with custom error message in the error summary
            const errorMessage = 'gardsnummer er påkrevd';
            // Ensure that either this value or gardsnummer and bruksnummer is provided
            if (!value && !bygningsnummer) {
              return errorMessage;
            }
            return true;
          }
        }
      }}
      control={control}
      name="gardsnummer"
      render={({ field: { onChange, ...rest }, fieldState, formState }) => (
        <NumberFieldWrapper
          fieldLabel={label}
          error={!!fieldState.error}
          onValueChange={(_, e) => {
            onChange(e.event);

            if (formState.isSubmitted) {
              trigger(['bruksnummer', 'bygningsnummer']);
            }
          }}
          {...rest}
        />
      )}
    />
  );
};
